import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        games: [],
        newGame: null,
        game: null,
    },
    mutations: {
        loadGames(state, payload) {
			state.games = payload
		},
        loadGame(state, payload) {
			state.game = payload
		},
        addGame(state, payload) {
           const index = state.games.length
			Vue.set(state.games, index, payload)   
        },
        updateGame(state, payload) {
            const update = state.games.find((game) => game.id == payload.id);
            const index = state.games.indexOf(update);
			Vue.set(state.games, index, { ...update, ...payload })   
        },
        deleteGame(state, payload) {
            state.games = state.games?.filter(s => s.id !== payload);  
        },
        setNewGame(state, payload) {
            state.newGame = payload;
        }
    },
    actions: {
        async fetchAllGames({ commit }) {
            commit('clearError')
            commit('setLoading', true)
            
            try {
                const result = await http.get(`/game`);
                //console.log(result)
                if (result) {
                   const games = await result.data 
                   commit('loadGames', games)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchUserGames({ commit, getters }, payload = null) {
            commit('clearError')
            commit('setLoading', true)
            
            let userId = getters.user.id;

            if (payload) {
                userId = payload;
            }

            try {
                const result = await http.get(`/game/users/${ userId }`);
                //console.log(result)
                if (result) {
                   const games = await result.data 
                   commit('loadGames', games)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchGame({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/game/${ payload }`);
                /* console.log(result) */
                if (result) {
                   const game = await result.data 
                   commit('loadGame', game)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //admin
        async addGame({ commit, getters }, payload) {
            commit('clearError')
            commit('setLoading', true)

            payload.userId = getters.user.id;
            //console.log(payload)

            try {
                const result = await http.post(`/game`, payload);
                /* console.log(result) */
                if (result) {
                   const game = await result.data 
                   commit('addGame', game)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async updateGame({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.put(`/game/${payload.id}`, payload);
                commit('updateGame', payload);              
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteGame({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/game/${payload}`);
                commit('deleteGame', payload);              
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //professor => rewrite game, market-segments, 
        async createGame({ commit, getters }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const userId = getters.user.id;
            //console.log(userId)
            const gameDto = {
                category: payload.set.item,
                round: payload.round,
                rounds: payload.rounds,
                description: payload.description,
                num_teams: payload.num_teams,
                userId: userId
            }
            try {
                const result = await http.post(`/game`, gameDto);
                
               if (result) {
                    const gameId = result.data.id;
                    
                    /* rewrite market-segments */
                    const game_id = payload.set.value;
                    const round = payload.round;
                    
                    const market = await http.get(`/market-segment/${ game_id }?round=${round}`);
                    if (market?.data) {
                        market.data.map(async(seg) => {
                            const segment = { 
                                gameId: gameId,
                                round: round,
                                segmentId: seg.segmentId,
                                max_price: seg.max_price,
                                min_price: seg.min_price,
                                lowest_price: seg.lowest_price,
                                best_quality: seg.best_quality,
                                on_line: seg.on_line,
                                off_line: seg.off_line,
                                family: seg.family,
                                attractiveness: seg.attractiveness,
                                personality: seg.personality,
                                social_status: seg.social_status,
                                fun: seg.fun,
                                friendship: seg.friendship,
                                pets: seg.pets,
                                independent: seg.independent,
                                brand_high: seg.brand_high,
                                brand_not: seg.brand_not,
                                brand_somehow: seg.brand_somehow,
                                design_classic: seg.design_classic,
                                design_art: seg.design_art,
                                design_business: seg.design_business,
                                design_casual: seg.design_casual,
                                design_innovative: seg.design_innovative,
                                design_1: seg.design_1,
                                design_2: seg.design_2,
                                design_3: seg.design_3,
                                design_4: seg.design_4,
                                design_5: seg.design_5,
                                material_1: seg.material_1,
                                material_2: seg.material_2,
                                material_3: seg.material_3,
                                material_4: seg.material_4,
                                material_5: seg.material_5,
                                manufacturing_1: seg.manufacturing_1,
                                manufacturing_2: seg.manufacturing_2,
                                manufacturing_3: seg.manufacturing_3,
                                manufacturing_4: seg.manufacturing_4,
                                manufacturing_5: seg.manufacturing_5
                            } 
                            /*console.log(segment)*/
                            await http.post(`/market-segment`, segment)
                        })
                    } 
                    /* rewrite advanced-feature */ 
                    const afs = await http.get(`/advanced-features/${ game_id }?round=${round}`);
                    if (afs?.data) {
                        afs.data.map(async(af) => {
                            const feature = {
                                gameId: gameId,
                                round: round,
                                segmentId: af.segmentId,
                                positioning_need: af.positioning_need,
                                power_bank_need: af.power_bank_need,
                                missed_items_warning_need: af.missed_items_warning_need,
                                danger_alarm_need: af.danger_alarm_need,
                                fridge_camera_need: af.fridge_camera_need,
                                loss_insurance_need: af.loss_insurance_need,
                                friendly_utilization_need: af.friendly_utilization_need,
                                profit_sharing_need: af.profit_sharing_need,
                                individual_pictures_need: af.individual_pictures_need
                            }
                            //console.log(feature)
                            await http.post(`/advanced-features`, feature)
                        })
                    }
                    /* rewrite independent chains */
                    const chains = await http.get(`/chain/${ game_id }`);
                    if (chains?.data) {
                        chains.data.map(async(ch) => {
                            const chain = {
                                gameId: gameId,
                                name: ch.name,
                                type: ch.type,
                                stores: ch.stores,
                                peak_market_coverage: ch.peak_market_coverage,
                                entry_fee: ch.entry_fee,
                                annual_fee: ch.annual_fee,
                                max_price: ch.max_price,
                                min_price: ch.min_price,
                                num_trademarks: ch.num_trademarks,
                                retail_margin: ch.retail_margin,
                                design_main: ch.design_main,
                                design_second: ch.design_second
                            }
                            //console.log(chain)
                            await http.post(`/chain`, chain)
                        }) 
                    }

                    /* rewrite media */
                    const medias = await http.get(`/media/game/${game_id}?round=${round}`);
                    if (medias?.data) {
                        medias.data.map(async(med) => {
                            const media = {
                                gameId: gameId,
                                round: round,
                                smm_cost: med.smm_cost,
                                content_ads_cost: med.content_ads_cost,
                                bloggers_influencers_cost: med.bloggers_influencers_cost,
                                banner_ads_cost: med.banner_ads_cost,
                                postal_cost: med.postal_cost,
                                outdoor_advertising_cost: med.outdoor_advertising_cost,
                                autoradio_podcasts_cost: med.autoradio_podcasts_cost,
                                tv_cost: med.tv_cost,
                                smm_coverage: med.smm_coverage,
                                content_ads_coverage: med.content_ads_coverage,
                                bloggers_influencers_coverage: med.bloggers_influencers_coverage,
                                banner_ads_coverage: med.banner_ads_coverage,
                                postal_coverage: med.postal_coverage,
                                outdoor_advertising_coverage: med.outdoor_advertising_coverage,
                                autoradio_podcasts_coverage: med.autoradio_podcasts_coverage,
                                tv_coverage: med.tv_coverage
                            }
                            //console.log(media)
                            await http.post(`/media`, media)
                        }) 
                    }

                    /* rewrite insights */
                    const insights = await http.get(`/insight/game/${game_id}`);
                    if (insights?.data) {
                        insights.data.map(async(ins) => {
                            const insight = {
                                gameId: gameId,
                                round: round,
                                segmentId: ins.segmentId,
                                weight: ins.weight,
                                text: ins.text
                            }
                            //console.log(insight)
                            await http.post(`/insight`, insight)
                        }) 
                    }

                    commit('setNewGame', result.data)
                }             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        }
    },
    getters: {
        games(state) {
            return state.games;
        },
        game(state) {
            return state.game;
        },
        num_teams (state) {
            let res = 5;
            if (state.game?.num_teams) {
                res = state.game?.num_teams;
            }
            return res;
        },
        newGame (state) {
            return state.newGame;
        }
    }
}